import React, { useEffect, useState } from 'react';
import { Divider, Input, message, Space } from 'antd';
import TipTap from '../Sections/TipTap';
import Title from 'antd/es/typography/Title';

interface OverviewData {
  description: any;
  ghgRatingText: string;
  sdgRatingText: string;
}

interface OverviewProps {
  data: OverviewData;
  setData: (path: string, value: any) => void;
  readonly?: boolean;
}

const Overview: React.FC<OverviewProps> = ({ data, setData, readonly = false }) => {
  const [overview, setOverview] = useState(data);

  useEffect(() => {
    setOverview(data);
  }, [data]);

  const handleOverviewChange = (key: string, value: any) => {
    if (readonly) return; // Prevent changes in readonly mode
    setOverview((prevOverview) => ({
      ...prevOverview,
      [key]: value
    }));
    setData(`overview.${key}`, value);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Title level={5}>Project type description</Title>
      <TipTap
        value={overview.description}
        onChange={(value) => handleOverviewChange('description', value)}
        readonly={readonly}
      />
      <Divider />
      <Space direction="vertical" style={{ flex: 1, width: '100%' }}>
        <Title level={5}>GHG chart key takeaway</Title>
        <Input.TextArea
          value={overview.ghgRatingText}
          onChange={(e) => handleOverviewChange('ghgRatingText', e.target.value)}
          placeholder="Enter ghg text here"
          style={{ marginBottom: '20px' }}
          disabled={readonly}
          maxLength={180}
          showCount
          rows={3}
          onKeyDown={(e) => {
            if (overview.ghgRatingText.length >= 180 && e.key !== 'Backspace') {
              e.preventDefault();
            }
          }}
          onKeyUp={(e) => {
            if (overview.ghgRatingText.length >= 180) {
              message.error('You have reached the maximum character limit');
            }
          }}
        />
      </Space>
      <Divider />
      <Space direction="vertical" style={{ flex: 1, width: '100%' }}>
        <Title level={5}>SDG chart key takeaway </Title>
        <Input.TextArea
          value={overview.sdgRatingText}
          onChange={(e) => handleOverviewChange('sdgRatingText', e.target.value)}
          placeholder="Enter sdg text here"
          style={{ marginBottom: '20px' }}
          disabled={readonly}
          maxLength={180}
          showCount
          rows={3}
          onKeyDown={(e) => {
            if (overview.sdgRatingText.length >= 180 && e.key !== 'Backspace') {
              e.preventDefault();
            }
          }}
          onKeyUp={(e) => {
            if (overview.sdgRatingText.length >= 180) {
              message.error('You have reached the maximum character limit');
            }
          }}
        />
      </Space>
    </Space>
  );
};

export default Overview;
